export function getSrcFromBase64(base64: string) {
  return `data:image/jpg;base64,${base64}`;
}
